<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-select size="medium" @change="getList()" v-model="type" placeholder="请选择" style="width:120px">
                <el-option label="全部账号" :value="0"></el-option>
                <el-option label="基础帐号" :value="1"></el-option>
                <el-option label="互通帐号" :value="2"></el-option>
            </el-select>
            <el-select size="medium" @change="getList()" v-model="stautus" placeholder="请选择" style="width:120px">
                <el-option label="未绑定" :value="1"></el-option>
                <el-option label="已使用" :value="2"></el-option>
                <el-option label="已过期" :value="3"></el-option>
                <el-option label="待转移" :value="4"></el-option>
            </el-select>
            <el-button style="margin-left: 0;" size="medium" type="primary" @click="syncFunc">批量绑定</el-button>
            <el-button style="margin-left: 0;" size="medium" type="primary" @click="jumpToPage('/main/customService/schoolManage/schoolGrant', {schoolId})">购买激活码</el-button>
            <el-button style="margin-left: 0;" size="medium" type="primary" @click="jumpToPage('/main/customService/schoolManage/newOrderList', {schoolId})">新增订单列表</el-button>
        </div>
        <div>
            <el-table
                :height="windowHeight - 245"
                :data="dataList"
                style="width: 100%" border
            >
                <el-table-column
                    label="激活码"
                    align="center" show-overflow-tooltip
                    prop="activeCode"
                >
                </el-table-column>
                <el-table-column
                    label="类型" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{scope.row.type == 1 ? '基础帐号' : '互通帐号'}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态"
                    align="center" show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{['', '未绑定', '已使用', '已过期', '待转移'][scope.row.status]}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="激活用户" show-overflow-tooltip
                    align="center"
                    prop="userName"
                >
                </el-table-column>

                <el-table-column
                    label="创建时间" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="激活时间" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.activeTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="到期时间" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.expireTime}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        listActiceCode,
        batchActiveAccount
    } from '@/api/schoolManage';

    export default {
        name: 'schoolList',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                stautus: 1,
                type: 0 ,
                dataList: []
            }
        },
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        components: {LocationSelector},
        created() {
            this.getList();
        },
        mixins: [windowResize, baseMixin],
        methods: {
            syncFunc() {
                batchActiveAccount({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.$message.success('同步成功');
                        this.getList();
                    })
            },
            getList() {
                listActiceCode({
                    schoolId: this.schoolId,
                    type: this.type,
                    stautus: this.stautus
                })
                    .then(data => {
                        this.dataList = data;
                    })
            },
        }
    }
</script>
<style>
    #moduleAppList .el-select {
        width: 120px;
    }
</style>
<style lang="scss" scoped>
    #moduleAppList {
        padding: 12px;

        .pagination-container {
            margin-top: 10px;
        }

        .top {
            padding-bottom: 10px;
            overflow: hidden;

        }

        a, .link {
            color: #409EFF;
            cursor: pointer;
        }

        .state-container {
            margin: 15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/activatingCodeList.vue